module.exports = __webpack_public_path__ + "static/media/live.ff57123b.png";